
export default {
  adminServer: "hingeguide.reell.com/admin/",
  // adminServer: '192.168.86.130:3000/'
};
